export const USER_REGISTER_SUCCESS = "register/USER_REGISTER_SUCCESS";
